// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar-module--avatar--3e5Ia","innerAvatar":"Avatar-module--innerAvatar--KQOCj","avatar__text":"Avatar-module--avatar__text--yt7Ka"};